/**
 * 呼び出し元画面の入力情報を格納するVO
 *
 * @export KYMW0800InputModel
 * @class KYMW0800InputModel
 */
export class KYMW0800InputModel {
  /** 機能ID */
  public funcID: string = <string>'';
  /** Ｐコード */
  public pCodeList: Array<any> = new Array<any>();
  /** 受注コード */
  public orderCode: string = <string>'';
  /** 媒体区分 */
  public mediumType: string = <string>'';
}

